module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "our-software",
    attrs: {
      "id": "our-software"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "product-heading"
  }, [_vm._v("our software")]), _vm._v(" "), _c('Blob'), _vm._v(" "), _c('div', {
    staticClass: "product-block"
  }, [_vm._m(0), _vm._v(" "), _c('StepUseAttachAnywhere'), _vm._v(" "), _c('StepVerticalValueProps'), _vm._v(" "), _c('StepAmazonValueProps'), _vm._v(" "), _c('StepOwnYourAudience')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-block-text product-block-element-left"
  }, [_c('div', {
    staticClass: "product-title"
  }, [_vm._v("MikMak Attach")]), _vm._v(" "), _c('div', {
    staticClass: "patent-badge"
  }, [_vm._v("Patent Pending")]), _vm._v(" "), _c('div', {
    staticClass: "product-subtitle"
  }, [_vm._v("Attach makes your media shoppable. It lives after \"the click\" or \"swipe up\" in digital and social channels.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61a4c84d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/site/MikMakAttach/MikMakAttach.vue
// module id = 487
// module chunks = 0